var Assessment = Chaplin.Model.extend({
    initialize: function() {
      _.bindAll(this, 'assessmentLoaded', 'assessmentLoadFailed', 'loadLocal');
    },
    url: function(isSaving) {
      return EF.ContentProvider.AssessmentService.getUrl(this, isSaving);
    },

    loadAssessment: function(options) {
      this.options = options;
      if(EF.options.local) {
        return this.loadLocal();
      } else {
        let onFail = options.failToLocal ? this.loadLocal : this.assessmentLoadFailed;
        return this.fetch(options)
          .done(this.assessmentLoaded)
          .fail(onFail);
      }
    },

    loadLocal: function() {
      var LocaleService = require('services/locale-service');
      var localData;
      var deferred = $.Deferred();
      deferred.done(this.assessmentLoaded);
      deferred.fail(this.assessmentLoadFailed);
      try {
        localData = require('/local-data/assessments/' + this.get('slug'));
        if(!localData.questions) {
          localData.questions = [];
        }
        if(localData.sections) {
          const sectionQuestions = localData.sections.reduce((result, section) => {
            return result.concat(section.questions);
          }, [])
          localData.questions = localData.questions.concat(sectionQuestions);
        }
        localData.questions.forEach(function(question) {
          if(typeof(question.text) !== 'string') {
            question.text = question.text[LocaleService.getLanguage()];
          }
          question.id = String(question.id);
          if(!question.correct_answer && question.correct_answers && question.correct_answers.length === 1) {
            question.correct_answer = question.correct_answers[0];
          }
          question.answers.forEach(function(answer) {
            if(typeof(answer.text) !== 'string') {
              answer.text = answer.text[LocaleService.getLanguage()];
            }
          });
        });
        this.set('local', true);
        deferred.resolve(localData);
      } catch(e) {
        deferred.reject();
      }
      return deferred;
    },

    assessmentLoaded: function(assessment) {
      this.set('questions', new EF.Collections.Assessments.QuestionsCollection(assessment.questions));
      if(this.options.split_questions) {
        this.set('original_questions', new EF.Collections.Assessments.QuestionsCollection(assessment.questions));
      }
      this.set('attempt', new EF.Models.Assessments.Attempt(assessment.attempt, {assessment: this}));
      this.set('passing_grade', assessment.passing_grade);
      this.trigger('assessments:load', this);
      EF.trigger('assessments:load', this);
    },

    assessmentLoadFailed: function() {
      this.trigger('assessments:load:failure');
      EF.trigger('assessments:load:failure');
    },

    filterQuestions: function(count, start) {
      start = start ? start - 1 : 0;
      var questions = this.get('questions').slice(start, start + count);
      this.set('questions', new EF.Collections.Assessments.QuestionsCollection(questions));
    }
  });

  _.extend(EF.Models.Assessments, {
    Assessment: Assessment
  });
